<template>
  <div class="back-arrow-nav" @click="goBack">
    <svg-icon class="back-arrow-nav__arrow" :icon="backArrowIcon" :height="40" :width="40"></svg-icon>

    <span class="back-arrow-nav__message">Back</span>
  </div>
</template>

<script>

import SvgIcon from '@/components/common/svgIcon'
import backArrowIcon from '@/assets/svg/back-arrow.svg'

export default {
  components: {
    SvgIcon
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    }
  },
  computed: {
    backArrowIcon () {
      return backArrowIcon
    }
  }
}

</script>

<style lang="scss">

.back-arrow-nav {
  display: inline-block;
  height: 19px;
  fill: color(blues, turner);
  cursor: pointer;

  &:hover {
    color: color(blues, normal);
  }

  &__arrow {
    display: inline-block;
    height: 10px;
    width: 21px;
  }

  &__message {
    margin-left: 6px;
    font-size: 16px;
    line-height: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// BackArrowNav.vue?43a91bae